// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  line-height: 1.3;
}

.intro_wrapper__cRM91 {
  padding-top: 50px;
  font-size: 1.8rem;
  text-align: justify; /* Căn đều hai bên */
}

@media (min-width: 992px) {
  .intro_wrapper__cRM91 {
    padding: 50px 30px 0 30px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Layout/Intro/intro.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,gBAAA;AAEJ;;AAAA;EACI,iBAAA;EACA,iBAAA;EACA,mBAAA,EAAA,oBAAA;AAGJ;;AAAA;EACI;IACI,oCAAA;EAGN;AACF","sourcesContent":["body{\n    line-height: 1.3;\n}\n.wrapper{\n    padding-top: 50px;\n    font-size: 1.8rem;\n    text-align: justify; /* Căn đều hai bên */\n\n}\n@media (min-width: 992px) {\n    .wrapper{\n        padding: 50px 30px 0 30px !important;\n\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `intro_wrapper__cRM91`
};
export default ___CSS_LOADER_EXPORT___;
